import { DonateRequest } from "../interface/donate.interface";

export class SendDonate {
  static readonly type = "[Donate] Send Donate";
  constructor(public payload: DonateRequest) {}
}
